import { put, call, takeLatest, select } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import client from '../client';
import { webhooksActions } from '../reducers/webhooks';
import { setLoading } from '../loading/loadingActions';
import { loadWebhooksListAction, CreateWebhookAction } from '../actionTypes/webhooks';
import { EventTypeState } from '../models/webhooks';
import { WebhookState } from '../models/webhook';

export function* loadWebhooksDetails() {
  const state = yield select();
  const { apps: { appDetails: { data } } } = state;
  const appId = data['id'];
  if (!appId) return;
  setLoading(true);
  yield put(webhooksActions.loadWebhooksList({ appId }));
  yield put(webhooksActions.loadEventTypes({ appId }));
}

export function* loadWebhooksList({ payload: { appId } }: PayloadAction<loadWebhooksListAction>) {
  try {
    const response: WebhookState[] = yield call(client, { url: `webhooks/${appId}` });
    yield put(webhooksActions.loadWebhooksListSuccess(response));
  } catch (error: any) {
    yield put(webhooksActions.loadWebhooksListFail(error));
  } finally {
    setLoading(false);
  }
}

export function* loadEventTypes({ payload: { appId } }: PayloadAction<loadWebhooksListAction>) {
  try {
    const response: EventTypeState[] = yield call(client, { url: `partners/${appId}/events/types` });
    yield put(webhooksActions.loadEventTypesSuccess(response));
  } catch (error: any) {
    yield put(webhooksActions.loadEventTypesFail(error));
  } finally {
    setLoading(false);
  }
}

export function* createWebhook({ payload: { data, res, rej } }: PayloadAction<CreateWebhookAction>) {
  const state = yield select();
  const { apps: { appDetails: { data: { id } } } } = state;

  try {
    const response: WebhookState = yield call(client, {
      url: `webhooks/${id}`,
      data,
      method: 'post',
    });
    yield put(webhooksActions.createWebhookSuccess(response));
    if (typeof res === 'function') {
      yield call(res);
    }
  } catch (error) {
    yield put(webhooksActions.createWebhookFail());
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  } finally {
    setLoading(false);
  }
}

export default function* webhooksSaga() {
  yield takeLatest(webhooksActions.loadWebhooksDetails.type, loadWebhooksDetails);
  yield takeLatest(webhooksActions.loadWebhooksList.type, loadWebhooksList);
  yield takeLatest(webhooksActions.loadEventTypes.type, loadEventTypes);
  yield takeLatest(webhooksActions.createWebhook.type, createWebhook);
}
